const validateName = function (Name) {
    const re = /^[a-zA-Z ]{2,}$/;
    return re.test(Name);
};
export default validateName;
